(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[454],{

/***/ 4836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export options */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2426);
/* harmony import */ var _components_article_card_article_card__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(502);
/* harmony import */ var _articles_carousel_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7392);
/* harmony import */ var _articles_carousel_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_articles_carousel_module_scss__WEBPACK_IMPORTED_MODULE_3__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var options = {
    slidesPerView: "auto",
    spaceBetween: 24,
    allowTouchMove: true,
    noSwiping: false,
    freeMode: true,
    breakpoints: {
        992: {
            watchOverflow: true
        }
    }
};
var ArticlesCarousel = function(param) {
    var articles = param.articles, ArticleCardProps = param.ArticleCardProps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_articles_carousel_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_articles_carousel_module_scss__WEBPACK_IMPORTED_MODULE_3___default().box),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .tq, _objectSpread({}, options, {
                children: articles.map(function(article) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .SwiperSlide */ .o5, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_articles_carousel_module_scss__WEBPACK_IMPORTED_MODULE_3___default().item),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_article_card_article_card__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
                                dark: true,
                                article: article
                            }, ArticleCardProps), article.id || Math.random())
                        })
                    }, article.id);
                })
            }))
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticlesCarousel);


/***/ }),

/***/ 9454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ArticlePage; },
  "getArticleById": function() { return /* binding */ getArticleById; },
  "getStaticPaths": function() { return /* binding */ getStaticPaths; },
  "getStaticProps": function() { return /* binding */ getStaticProps; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(9113);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(5102);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(5407);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./components/lazy-load-image/index.tsx + 2 modules
var lazy_load_image = __webpack_require__(9029);
// EXTERNAL MODULE: ./components/article-author-info/article-author-info.module.scss
var article_author_info_module = __webpack_require__(3489);
var article_author_info_module_default = /*#__PURE__*/__webpack_require__.n(article_author_info_module);
;// CONCATENATED MODULE: ./components/article-author-info/article-author-info.tsx



var ArticleAuthorInfo = function(props) {
    var articleAuthor = props.articleAuthor;
    if (!articleAuthor) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (article_author_info_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (article_author_info_module_default()).avatarContainer,
                children: articleAuthor.leadImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                    className: (article_author_info_module_default()).avatar,
                    imageUrl: articleAuthor.leadImage,
                    objectFit: "cover"
                }) : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (article_author_info_module_default()).name,
                children: articleAuthor.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (article_author_info_module_default()).bio,
                children: articleAuthor.bio
            })
        ]
    });
};
/* harmony default export */ var article_author_info = (ArticleAuthorInfo);

// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 68 modules
var esm = __webpack_require__(8124);
// EXTERNAL MODULE: ./components/roomstay-blog-image-block/clipped-box.tsx
var clipped_box = __webpack_require__(2859);
// EXTERNAL MODULE: ./helpers/DateHelper.ts
var DateHelper = __webpack_require__(3870);
// EXTERNAL MODULE: ./components/article-hero/article-hero.module.scss
var article_hero_module = __webpack_require__(5305);
var article_hero_module_default = /*#__PURE__*/__webpack_require__.n(article_hero_module);
;// CONCATENATED MODULE: ./components/article-hero/article-hero.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var ArticleHero = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var article = props.article;
    var ref5 = _slicedToArray((0,esm/* useElementSize */.h4)(), 2), imageRef = ref5[0], height = ref5[1].height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (article_hero_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: Math.atan(160 / 1920),
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: (article_hero_module_default()).background,
                style: {
                    backgroundColor: article.backgroundColor,
                    maxHeight: "calc(100% - ".concat(height / 5 * 2, "px)")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (article_hero_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (article_hero_module_default()).title,
                        children: article.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (article_hero_module_default()).overallInfo,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (article_hero_module_default()).articleInfo,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (article_hero_module_default()).author,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (article_hero_module_default()).avatarContainer,
                                                children: ((ref = article.author) === null || ref === void 0 ? void 0 : ref.leadImage) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                                    className: (article_hero_module_default()).avatar,
                                                    imageUrl: (ref1 = article.author) === null || ref1 === void 0 ? void 0 : ref1.leadImage,
                                                    objectFit: "cover"
                                                }) : null
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (article_hero_module_default()).name,
                                                        children: (ref2 = article.author) === null || ref2 === void 0 ? void 0 : ref2.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (article_hero_module_default()).jobTitle,
                                                        children: (ref3 = article.author) === null || ref3 === void 0 ? void 0 : ref3.jobTitle
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (article_hero_module_default()).article,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (article_hero_module_default()).category,
                                                children: (ref4 = article.categories) === null || ref4 === void 0 ? void 0 : ref4.map(function(category) {
                                                    return category.name;
                                                }).join(", ")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: article.lastUpdated ? (0,DateHelper/* formatDate */.p)(article.lastUpdated) : null
                                            }),
                                            article.readingTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: "".concat(article.readingTime, " min").concat(article.readingTime > 1 ? "s" : "", " read")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            article.summary ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (article_hero_module_default()).summary,
                                dangerouslySetInnerHTML: {
                                    __html: article.summary
                                }
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: imageRef,
                className: (article_hero_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (article_hero_module_default()).imageBox,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (article_hero_module_default()).imageContent,
                            children: article.leadPortraitImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                className: (article_hero_module_default()).image,
                                imageUrl: article.leadPortraitImage,
                                objectFit: "cover"
                            }) : null
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (article_hero_module_default()).arrow,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "Scroll to read"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var article_hero = (ArticleHero);

// EXTERNAL MODULE: ./components/loading/index.tsx
var loading = __webpack_require__(8083);
// EXTERNAL MODULE: ./components/meta-block/MetaBlock.tsx
var MetaBlock = __webpack_require__(2135);
// EXTERNAL MODULE: ./components/not-found/not-found.tsx
var not_found = __webpack_require__(1200);
// EXTERNAL MODULE: ./components/roomstay-blog-highlight-article/roomstay-blog-highlight-article.tsx
var roomstay_blog_highlight_article = __webpack_require__(1600);
// EXTERNAL MODULE: ./components/articles-carousel/articles-carousel.tsx
var articles_carousel = __webpack_require__(4836);
// EXTERNAL MODULE: ./components/roomstay-blog-related-articles/roomstay-blog-related-articles.module.scss
var roomstay_blog_related_articles_module = __webpack_require__(8095);
var roomstay_blog_related_articles_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_related_articles_module);
// EXTERNAL MODULE: ./components/button/index.tsx
var components_button = __webpack_require__(4656);
// EXTERNAL MODULE: ./shared/constant.ts
var constant = __webpack_require__(678);
;// CONCATENATED MODULE: ./components/roomstay-blog-related-articles/roomstay-blog-related-articles.tsx






var RoomstayBlogRelatedArticles = function(param) {
    var articles = param.articles;
    if (!articles || articles.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_related_articles_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_related_articles_module_default()).title,
                children: "More articles"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(articles_carousel/* default */.Z, {
                articles: articles || [],
                ArticleCardProps: {
                    dark: false
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_related_articles_module_default()).btnContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                    link: constant/* BLOG_HOME_PAGE */.aE,
                    children: "MORE POSTS"
                })
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_related_articles = (RoomstayBlogRelatedArticles);

// EXTERNAL MODULE: ./components/share-icons/share-icons.tsx + 5 modules
var share_icons = __webpack_require__(3394);
// EXTERNAL MODULE: ./contexts/ThemeContext.tsx
var ThemeContext = __webpack_require__(109);
// EXTERNAL MODULE: ./models/ArticleModel.ts + 1 modules
var ArticleModel = __webpack_require__(4618);
;// CONCATENATED MODULE: ./types/article.d.ts
var ArticleTheme;
(function(ArticleTheme) {
    ArticleTheme["Light"] = "light";
    ArticleTheme["Dark"] = "dark";
})(ArticleTheme || (ArticleTheme = {}));

// EXTERNAL MODULE: ./types/builder.d.ts
var builder_d = __webpack_require__(3109);
// EXTERNAL MODULE: ./utils/Article.ts
var Article = __webpack_require__(5269);
// EXTERNAL MODULE: ./utils/Builder.ts
var Builder = __webpack_require__(7637);
// EXTERNAL MODULE: ./modules/pages/article/article.module.scss
var article_module = __webpack_require__(5059);
var article_module_default = /*#__PURE__*/__webpack_require__.n(article_module);
;// CONCATENATED MODULE: ./modules/pages/article/index.tsx
/* provided dependency */ var process = __webpack_require__(8584);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




















function getStaticProps(_) {
    return _getStaticProps.apply(this, arguments);
}
function _getStaticProps() {
    _getStaticProps = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var params, slug, pageSlug, article, convertedArticle, relatedArticles, upnextArticle;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    params = param.params;
                    slug = params.slug;
                    pageSlug = Array.isArray(slug) ? slug.join("/") : slug;
                    _ctx.next = 5;
                    return ArticleModel/* default.findArticle */.Z.findArticle({
                        params: {
                            url: pageSlug
                        },
                        includeUnpublished: true
                    });
                case 5:
                    article = _ctx.sent;
                    if (article) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", /*#__PURE__*/ (0,jsx_runtime.jsx)(not_found["default"], {}));
                case 8:
                    convertedArticle = ArticleModel/* default.fromBuilderContent */.Z.fromBuilderContent(article);
                    _ctx.next = 11;
                    return (0,Article/* getRelatedArticle */.$$)(convertedArticle);
                case 11:
                    relatedArticles = _ctx.sent;
                    _ctx.t0 = ArticleModel/* default */.Z;
                    _ctx.next = 15;
                    return ArticleModel/* default.findNextById */.Z.findNextById(article.id, article.createdDate);
                case 15:
                    _ctx.t1 = _ctx.sent;
                    upnextArticle = _ctx.t0.fromBuilderContent.call(_ctx.t0, _ctx.t1);
                    return _ctx.abrupt("return", {
                        props: {
                            page: article,
                            relatedArticles: relatedArticles,
                            upnextArticle: upnextArticle
                        },
                        revalidate: 5
                    });
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getStaticProps.apply(this, arguments);
}
function getStaticPaths() {
    return _getStaticPaths.apply(this, arguments);
}
function _getStaticPaths() {
    _getStaticPaths = _asyncToGenerator(runtime_default().mark(function _callee() {
        var pages, paths;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return ArticleModel/* default.getAllArticles */.Z.getAllArticles(true, false, "data.url");
                case 2:
                    pages = _ctx.sent;
                    paths = pages.filter(function(page) {
                        return page.data.url;
                    }).map(function(page) {
                        return ArticleModel/* default.convertBuilderURL2Slug */.Z.convertBuilderURL2Slug(page.data.url);
                    });
                    return _ctx.abrupt("return", {
                        paths: paths,
                        fallback: true
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getStaticPaths.apply(this, arguments);
}
var getArticleById = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(articleId, enrich) {
        var article;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (articleId) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.next = 4;
                    return ArticleModel/* default.findArticle */.Z.findArticle({
                        params: {
                            modelId: Array.isArray(articleId) ? articleId[0] : articleId
                        },
                        enrich: enrich
                    });
                case 4:
                    article = _ctx.sent;
                    return _ctx.abrupt("return", article);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getArticleById(articleId, enrich) {
        return _ref.apply(this, arguments);
    };
}();
function ArticlePage(props) {
    var ref, ref1, ref2;
    var page = props.page, upNextArticle = props.upNextArticle, relatedArticles = props.relatedArticles;
    var article = (0,react.useMemo)(function() {
        return ArticleModel/* default.fromBuilderContent */.Z.fromBuilderContent(page);
    }, [
        page
    ]);
    var router = (0,next_router.useRouter)();
    var theme = (0,ThemeContext/* useThemeContext */.TC)();
    (0,react.useEffect)(function() {
        if (theme.themeStyle === ThemeContext/* ThemeStyles.Blog */.Cz.Blog) return;
        theme.setThemeStyle(ThemeContext/* ThemeStyles.Blog */.Cz.Blog);
        return function() {
            theme.setThemeStyle(null);
        };
    }, []);
    (0,react.useEffect)(function() {
        theme.setArticleTheme(article.theme || ArticleTheme.Light);
        return function() {
            theme.setArticleTheme(null);
        };
    }, [
        article
    ]);
    var targetUrl = article === null || article === void 0 ? void 0 : article.url;
    if (true) {
        targetUrl = "".concat((window === null || window === void 0 ? void 0 : window.origin) || "").concat(article === null || article === void 0 ? void 0 : article.url);
    }
    if (router.isFallback || !article) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading/* default */.Z, {});
    }
    var schema = {
        "@context": "https://schema.org/",
        "@type": "Article",
        headline: article.title,
        image: article.leadImage || article.leadPortraitImage || "",
        author: [
            {
                "@type": "Person",
                name: (ref = article.author) === null || ref === void 0 ? void 0 : ref.name,
                jobTitle: (ref1 = article.author) === null || ref1 === void 0 ? void 0 : ref1.jobTitle
            },
            {
                "@type": "Organization",
                name: "Roomstay",
                url: "https://roomstay.io/"
            }, 
        ],
        datePublished: article.firstPublished ? new Date(article.firstPublished).toJSON() : null,
        dateModified: article.lastUpdated ? new Date(article.lastUpdated).toJSON() : null,
        publisher: {
            "@type": "Organization",
            name: "Roomstay",
            logo: {
                "@type": "ImageObject",
                url: "https://roomstay.io/favicon-32x32.png"
            }
        }
    };
    var generateSchemas = (ref2 = article.schemas) === null || ref2 === void 0 ? void 0 : ref2.map(function(param, index) {
        var type = param.type, value = param.value;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: type,
            dangerouslySetInnerHTML: {
                __html: value
            }
        }, index);
    });
    var canonicalSlug = article === null || article === void 0 ? void 0 : article.url;
    if (canonicalSlug === null || canonicalSlug === void 0 ? void 0 : canonicalSlug.endsWith("/")) {
        canonicalSlug = canonicalSlug.replace(/\/$/, "");
    }
    var canonicalUrl = process.env.SITE_URL || "https://www.roomstay.io" + canonicalSlug;
    var _seoTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MetaBlock/* default */.Z, {
                title: (_seoTitle = article.seoTitle) !== null && _seoTitle !== void 0 ? _seoTitle : article.title,
                description: article.seoDescription,
                leadImage: article.leadImage,
                keywords: article.keywords,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        children: JSON.stringify(schema, null, 2)
                    }),
                    generateSchemas
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(article_hero, {
                article: article
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_react_es5/* BuilderComponent */.VD, {
                model: builder_d/* BUILDER_MODEL.ARTICLE */.A.ARTICLE,
                content: page,
                data: (0,Builder/* getBlockDataMap */.LV)(page)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (article_module_default()).footer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (article_module_default()).divider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(article_author_info, {
                        articleAuthor: article.author
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(share_icons/* default */.Z, {
                        shareUrl: targetUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(roomstay_blog_highlight_article/* default */.Z, {
                        fixedArticle: upNextArticle,
                        arrowText: "Up Next"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(roomstay_blog_related_articles, {
                        articles: relatedArticles
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 3489:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"article-author-info_container__bWn6F","avatarContainer":"article-author-info_avatarContainer__4H3qi","avatar":"article-author-info_avatar__yVNqz","name":"article-author-info_name__Bmzk3","bio":"article-author-info_bio__eJ9pV"};

/***/ }),

/***/ 5305:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"article-hero_container__Q_xqP","background":"article-hero_background__KyDdL","content":"article-hero_content__Lcmms","title":"article-hero_title__TZSCu","overallInfo":"article-hero_overallInfo__jfYUe","articleInfo":"article-hero_articleInfo__xF0ax","author":"article-hero_author__CqSNY","avatarContainer":"article-hero_avatarContainer__jCQ3f","avatar":"article-hero_avatar__A_nk0","name":"article-hero_name__jSmwa","jobTitle":"article-hero_jobTitle__BudzA","article":"article-hero_article___meno","category":"article-hero_category__dVnhy","summary":"article-hero_summary__gjFL5","imageContainer":"article-hero_imageContainer__rkmDs","imageBox":"article-hero_imageBox__m73wK","arrow":"article-hero_arrow__9LujT","imageContent":"article-hero_imageContent__z_CCM","image":"article-hero_image__8Nj6V"};

/***/ }),

/***/ 7392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"articles-carousel_container__x82Kb","box":"articles-carousel_box__U6byE","item":"articles-carousel_item__mRGsi"};

/***/ }),

/***/ 8095:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"roomstay-blog-related-articles_root__R_5LD","title":"roomstay-blog-related-articles_title__J0Bun","btnContainer":"roomstay-blog-related-articles_btnContainer__T8zQN","btn":"roomstay-blog-related-articles_btn__FarOP"};

/***/ }),

/***/ 5059:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"article_footer__DHiPc","divider":"article_divider__Y4dT5"};

/***/ })

}]);